/**
 * Список входящий query параметров
 * */
export interface IQueryParams {
  source?: string;
  targetPage?: string;
  estimationTarget?: string;
  address?: string;
}

/**
 * Список страниц, где будет использована форма добавления объекта в МД
 * */
export enum ETargetPage {
  myHomePage, //valuation-my-home-page-frontend
  myHomeCard, //valuation-my-home-card-frontend
  newbuildingMyHome, //valuation-my-home-newbuilding-frontend
}

export interface IPage {
  targetPage: ETargetPage | string;
  source?: string;
}
